import {
    acceptAcceptButtonText,
    addThisCalendarAcceptButtonText,
    viewCalendarAcceptButtonText,
} from './createSharingMessageActionText.locstring.json';
import loc from 'owa-localize';
import * as Constants from './constants';

export default function createSharingMessageActionText(action: string): string {
    switch (action) {
        case Constants.ACCEPT_AND_VIEW_CALENDAR:
            // In React, accepting sharing message is broken into two actions, an "Accept" and then a
            // "View Calendar". So the "Accept and view calendar" button no longer makes sense, so we'll default to
            // just "Accept" instead.
            return loc(acceptAcceptButtonText);
        case Constants.ADD_THIS_CALENDAR:
            return loc(addThisCalendarAcceptButtonText);
        case Constants.VIEW_CALENDAR:
            return loc(viewCalendarAcceptButtonText);
        default:
            /*CalendarSharingAction.Accept is the old default value*/
            return loc(acceptAcceptButtonText);
    }
}
